module.exports = __webpack_public_path__ + "img/gettysburg-national-park-commission.1cf62c38.png";